var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlElectricalKettleFilled = function SvgHtlElectricalKettleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.5 15h-7a.5.5 0 0 1-.5-.5v-.094c.185-2.877.5-8.693.5-9.405 0-.789-.443-.976-1.07-1.154l-.069-.02a.5.5 0 0 1-.343-.619l.534-1.846a.5.5 0 0 1 .48-.361h5.483a1.49 1.49 0 0 1 1.494 1.372l.052.627h.439A1.5 1.5 0 0 1 13 4.5V7a1.5 1.5 0 0 1-1.487 1.5l.485 5.9a.566.566 0 0 1 0 .069v.034A.5.5 0 0 1 11.5 15ZM8 5a.5.5 0 0 0-.465.314l-1 2.5a.5.5 0 0 0 .464.686h1.262l-.726 1.814a.5.5 0 1 0 .93.371l1-2.5A.5.5 0 0 0 9 7.5H7.738l.726-1.814a.5.5 0 0 0 0-.382A.5.5 0 0 0 8 5Zm3.143-1 .287 3.5h.069a.5.5 0 0 0 .5-.5V4.5a.5.5 0 0 0-.5-.5h-.356Z"
  })));
};
export default SvgHtlElectricalKettleFilled;